import styled from 'styled-components';
import { Input } from '../Login/styled';

export const Filters = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
`;

export const Search = styled(Input)`
  flex: 1 1 200px;
  color: var(--ink);
`;

export const Toggle = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
`;

/** A card's set and number, under it. */
export const CardNumber = styled.span`
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: var(--muted);
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
